<template>
  <tr v-if="length == 0 && colspan != 1">
    <td :colspan="this.colspan" class="text-center">
      <span v-if="this.awaitReload" class="loader"><span></span></span>
      <span v-else class="no_data">{{ $t('table.noData') }}</span>
    </td>
  </tr>

  <div class="d-flex justify-content-center" v-if="length == 0 && colspan == 1">
    <span v-if="this.awaitReload" class="loader"><span></span></span>
    <span v-else class="no_data">{{ $t('table.noData') }}</span>
  </div>
</template>

<style scoped>
.no_data {
  background-color: rgb(80, 80, 80, 0.5);
  padding: 5px 20px;
  border-radius: 0.5em;
  color: black;
}
</style>

<script>
export default {
  name: 'no_data',
  props: {
    awaitReload: {
      type: Boolean,
      default: true
    },
    length: {
      type: Number,
      default: 0
    },
    colspan: {
      type: Number,
      default: 1
    }
  }
};
</script>
